import { Business, Contacts } from '~/types';
import axios, { auth, ResponseType } from './axios';

export const getBusinessById = (id?: string): ResponseType<Business> => {
  const businessId = id || auth.getProfile();
  return axios.get(`/businesses/${businessId}`);
};

export const editBusiness = (body: Business): ResponseType<Business> => {
  const businessId = body.id || auth.getProfile();
  return axios.put(`/businesses/${businessId}`, body);
};

export const editContacts = (
  businessId: string,
  body: { contacts?: Contacts }
): ResponseType<Business> => {
  return axios.post(`/businesses/${businessId}/contacts`, body);
};
